import { InjectionToken } from '@angular/core';

export let ShellHeightToken = new InjectionToken('ShellHeight');